function getDeviceId() {
    let deviceId = localStorage.getItem('deviceId');
    if (!deviceId) {
        deviceId = 'device-' + Math.random().toString(36).substr(2, 16);
        localStorage.setItem('deviceId', deviceId);
    }
    return deviceId;
}

async function getReplacements() {
    var firebaseConfig = {
        apiKey: "AIzaSyCLY9LJGKcgMr_CrNPEmf3AFfnJj6w5SZ4",
        authDomain: "bookbundlerapp.firebaseapp.com",
        projectId: "bookbundlerapp",
        appId: "1:387058334832:ios:bb889d66f8ab2fe9e088b5"
    };

    if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
        console.log("Firebase initialized successfully.");
    } else {
        console.log("Firebase already initialized.");
    }

    const db = firebase.firestore();
    const auth = firebase.auth();
    const deviceId = getDeviceId(); // Get the device ID

    const orderNumber = document.getElementById('order-number-replacement').value.trim();
    const resultDiv = document.getElementById('replacement-results');
    resultDiv.innerHTML = ''; // Clear previous results

    if (!orderNumber) {
        console.error('Order number cannot be empty.');
        resultDiv.innerHTML = '<p style="color: red;">Order number cannot be empty.</p>';
        return;
    }

    console.log("Order Number Entered: ", orderNumber);

    auth.onAuthStateChanged(async user => {
        if (user) {
            try {
                // Check for existing replacement requests by device ID
                const recentRequestsQuery = await db.collection('replacementrequest')
                    .where('deviceId', '==', deviceId)
                    .orderBy('timestamp', 'desc')
                    .limit(1)
                    .get();

                if (!recentRequestsQuery.empty) {
                    const lastRequest = recentRequestsQuery.docs[0].data();
                    const lastRequestTime = lastRequest.timestamp.toDate();
                    const currentTime = new Date();
                    const timeDifference = currentTime - lastRequestTime;
                    const twelveHoursInMillis = 12 * 60 * 60 * 1000;

                    if (timeDifference < twelveHoursInMillis) {
                        resultDiv.innerHTML = '<p style="color: red;">This device can only make 1 replacement request every 12 hours.</p>';
                        return;
                    }
                }

                console.log("Attempting to fetch document from Firestore with ID: ", orderNumber);
                const docRef = db.collection('Replacement Orders').doc(orderNumber);
                const doc = await docRef.get();
                console.log("Document fetched:", doc);

                if (doc.exists) {
                    const data = doc.data();
                    console.log("Document data:", data);
                    if (data.replacement) {
                        resultDiv.innerHTML = '<p style="color: red;">This order has already received replacements.</p>';
                    } else {
                        let totalBooks = 0;
                        const lineItemsHtml = await Promise.all(data.line_items.map(async (item, index) => {
                            const variantIDString = item.variant_id.toString();
                            console.log("Checking Pooled Inventory for variant ID: ", variantIDString);
                            const pooledQuerySnapshot = await db.collection('Pooled Inventory').where('variantID', '==', variantIDString).get();
                            let numberOfBooks = item.quantity;
                            let poolProduct = item.sku; // Default to SKU if no pool product is found

                            if (!pooledQuerySnapshot.empty) {
                                const pooledData = pooledQuerySnapshot.docs[0].data();
                                console.log("Pooled Inventory data: ", pooledData);
                                numberOfBooks *= pooledData.poolMultiplier;
                                poolProduct = pooledData.poolProduct || item.sku; // Use pool product if available
                                if (pooledData.poolMultiplier === 1) {
                                    console.log("Skipping line item with pool multiplier of 1.");
                                    return null; // Skip this item
                                }
                            } else {
                                console.log("No matching Pooled Inventory document found for variant ID: ", variantIDString);
                                return null; // Skip this item
                            }
                            totalBooks += numberOfBooks;
                            return `
                                <div class="row-replacement">
                                    <div class="column-replacement">
                                        <p>${poolProduct}</p>
                                        <p><strong># of Books in order:</strong> ${numberOfBooks}</p>
                                    </div>
                                    <div class="divider-vertical"></div>
                                    <div class="column-replacement">
                                        <input type="number" id="quantity-${index}" placeholder="Enter quantity you need replaced" class="replacement-input" data-max-books="${numberOfBooks}">
                                    </div>
                                </div>
                                <hr class="replacement-divider">
                            `;
                        }));
                        const eligibleBooks = Math.round(totalBooks * 0.10);
                        resultDiv.innerHTML = `
                            <h3>Order Number: ${data.order_number}</h3>
                            <p style="color: red; font-weight: bold;">This order is eligible for ${eligibleBooks} replacement books</p>
                            <div class="container-replacement">
                                <div class="row-replacement header-row"></div>
                                ${lineItemsHtml.filter(item => item !== null).join('')}
                            </div>
                            <textarea id="customer-notes" placeholder="Enter customer notes/comments" class="replacement-textarea"></textarea>
                            <button id="request-replacements" class="replacement-button">Request Replacements</button>
                        `;

                        document.getElementById('request-replacements').addEventListener('click', async () => {
                            try {
                                let totalRequested = 0;
                                const replacementRequestData = {
                                    orderNumber: orderNumber,
                                    lineItems: {},
                                    customerNotes: document.getElementById('customer-notes').value,
                                    booksOrdered: 0, // Add a field to store the number of books ordered
                                    deviceId: deviceId, // Add the device ID to the request
                                    timestamp: firebase.firestore.FieldValue.serverTimestamp() // Add the timestamp
                                };

                                data.line_items.forEach((item, index) => {
                                    const quantityInput = document.getElementById(`quantity-${index}`);
                                    if (!quantityInput) {
                                        console.error(`quantityInput for index ${index} is null`);
                                        return;
                                    }

                                    const quantity = quantityInput.value || '0';
                                    const quantityInt = parseInt(quantity, 10) || 0;
                                    const maxBooks = parseInt(quantityInput.dataset.maxBooks, 10);

                                    console.log(`Processing SKU: ${item.sku}, Requested: ${quantityInt}, Max: ${maxBooks}`);

                                    replacementRequestData.lineItems[item.sku] = quantityInt;
                                    totalRequested += quantityInt;

                                    replacementRequestData.booksOrdered += maxBooks; // Add to the number of books ordered
                                });

                                if (totalRequested > eligibleBooks) {
                                    alert('Replacement requests are limited to 10% of an eligible order.');
                                    return;
                                }

                                // Confirmation popup
                                if (confirm("Are you sure? Only 1 replacement request per order.")) {
                                    try {
                                        await db.collection('Replacement Orders').doc(orderNumber).update({ replacement: true });
                                        await db.collection('replacementrequest').doc(orderNumber).set(replacementRequestData);

                                        alert('Replacements requested successfully.');

                                        // Reset form fields
                                        document.getElementById('replacement-results').innerHTML = '';
                                        document.getElementById('order-number-replacement').value = '';
                                        document.getElementById('customer-notes').value = '';
                                    } catch (saveError) {
                                        console.error('Error saving replacements:', saveError);
                                    }
                                } else {
                                    return;
                                }
                            } catch (error) {
                                console.error('Error processing replacements:', error);
                            }
                        });
                    }
                } else {
                    console.log("No matching document found with ID:", orderNumber);
                    resultDiv.innerHTML = '<p style="color: red;">This order is not eligible for replacements</p>';
                }
            } catch (error) {
                console.error('Error getting document:', error); // Add logging
                resultDiv.innerHTML = '<p style="color: red;">Error retrieving order information. Please try again later.</p>';
            }
        } else {
            console.error('User is not authenticated.');
            resultDiv.innerHTML = '<p style="color: red;">One Moment while we pull your order</p>';
        }
    });

    if (!auth.currentUser) {
        console.log("User not authenticated. Attempting anonymous sign-in.");
        auth.signInAnonymously().catch(error => {
            console.error("Error signing in anonymously:", error);
            resultDiv.innerHTML = '<p style="color: red;">Error signing in anonymously. Please try again later.</p>';
        });
    }
}

document.getElementById('get-replacements-btn-replacement').addEventListener('click', getReplacements);